export default "__VITE_ASSET__BgzHmLJO__"